export default __webpack_public_path__ + "static/media/resumes_main.6755b025.png";